import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { App } from './App.tsx';
import './styles.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // A food's macros don't change while you're looking at them, and phone
      // connections are worth being frugal with.
      staleTime: 60_000,
      retry: 1,
      // Installed on a phone the app is resumed far more often than it is
      // loaded, and a resume is exactly when the data is most likely to have
      // moved on -- food logged from a chat, or on another device. staleTime
      // still applies, so flicking between apps costs nothing; coming back
      // after a minute or more refetches.
      refetchOnWindowFocus: true,
    },
  },
});

const root = document.getElementById('root');
if (!root) throw new Error('#root missing from index.html');

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
);
